export default {
  title01: "目前天氣",
  title02: "24小時",
  title03: "查看未來十日天氣預報",
  title04: "空氣質量指數",
  title05: "查看所有資訊",
  title06: "日出和日落",
  title07: "月相",
  title08: "下一次滿月",
  title09: "下一次新月",
  title10: "日",
  title11: "夜",
  title12: "日出",
  title13: "日落",
  title14: "月出",
  title15: "月落",
  title16: "來源",
  title17: "開始",
  title18: "結束",
  title19: "使用目前位置",
  title20: "搜索城市",
  title21: "體感溫度",
  title22: "陰影下的體感溫度",
  title23: "現在",
  title24: "今天",
  title25: "星期日",
  title26: "星期一",
  title27: "星期二",
  title28: "星期三",
  title29: "星期四",
  title30: "星期五",
  title31: "星期六",
  title32: "載入中...",
  title33: "現在",
  title34: "每小時",
  title35: "每日",
  title36: "日與月",
  title37: "空氣質素",
  title38: "請聯絡 : xlf550402@gmail.com",
  title39: "隱私協議",
  title40: "版權所有 © comfortweather.com 2020 - 2024. 保留所有權利",
  title41: "數據由",
  title42: "最高氣溫",
  title43: "最低氣溫",
  title44: "接受",
  title45: "感謝您使用 ComfortWeather！為了更好地保護您的合法權益，請在使用前仔細閱讀 ",
  title46: "隱私權政策",
  title47: " 。",
  title48: "提供",
  title49: "請聯絡 : xyjph123@gmail.com",
  title50: "版權所有 © 24hweather.com 2020 - 2024. 保留所有權利",
  title51: "感謝您使用 24hweather！為了更好地保護您的合法權益，請在使用前仔細閱讀 ",
};
